import React, { useEffect, useState } from 'react'
import '../style/SogliaTaglia.scss'
import axios from 'axios';
import { useSelector, useDispatch } from 'react-redux';
import md5 from 'md5';
import { setSoglia, setTaglia } from '../features/userSlice';
import HeaderBack from '../components/FaiDaTe/_HeaderBack';
import {ReactComponent as More} from '../assets/new-icons/plus.svg';
import {ReactComponent as Less} from '../assets/new-icons/minus.svg';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ConfermaBTN from '../components/ConfermaBTN/ConfermaBTN';
import {ReactComponent as Change} from '../assets/new-icons/change.svg';

export default function SogliaTaglia() {
    const dispatch = useDispatch()
    const customerId = useSelector((user) => user.user.info.customer_id)
    const tkn = md5(customerId + 'oYmAIdtki%lu') 
    const taglia = useSelector((user) => user.user.importo_taglia)
    const soglia = useSelector((user) => user.user.importo_soglia)
    const idGroup = useSelector((user) => user.user.idGruppo)
    const [step, setStep] = useState(0)
    const [newTaglia, setNewTaglia] = useState(taglia)
    const [newSoglia, setNewSoglia] = useState(soglia)
    const url = `https://my.revoluce.it/area_utente/gestione/api/customers/setSogliaTaglia.php?customer_id=${customerId}&tkn_pvt=${tkn}&soglia_incasso=${newSoglia}&importo_taglia=${newTaglia}`


    useEffect(() => {
        init()
    },[])

    const init = async () => {
        const url = `https://my.revoluce.it/area_utente/gestione/api/customers/getSogliaTaglia.php?customer_id=${customerId}&tkn_pvt=${tkn}`
        const { data } = await axios.get(url)
        const result = data.data[0]
        dispatch(setTaglia(result.importo_taglia))
        dispatch(setSoglia(result.soglia_incasso))
    }

    
    return (
        <div className="faiDaTe_component">
            <div className="sogliaTaglia height">
                {step === 0 ? (
                    <>
                        <HeaderBack text="Fai da te" step={step} setStep={setStep}/>
                        <div className="body">
                            <p className="title">Taglia e soglia</p>
                            <p className="secondary">Imposta taglia e soglia:</p>
                            {
                                idGroup === 2 || idGroup === 3 ? (
                                    <>
                                        <p className="description">Il tuo piano attuale non prevede la modifica della soglia.</p> 
                                        <div style={{opacity: "0.5"}} className="sogliaBox">
                                            <span className="less"><Less /></span>
                                            <p className='value'>0€</p>
                                            <span className="more"><More /></span>
                                        </div>
                                        <p className="label" style={{textAlign: 'center', marginBottom: '30px'}}>
                                            La soglia non può essere inferiore a 5€
                                        </p>
                                    </>
                                ) : (
                                    <>
                                        <p className="description">Quando il tuo Saldo ( complessivo dei consumi giornalieri ) scende sotto la soglia di</p> 
                                        <div className="sogliaBox">
                                            <span className="less" onClick={() => newSoglia === 5 ? null : setNewSoglia(parseFloat(newSoglia) - 5)}><Less /></span>
                                            <p className='value'>{newSoglia}€</p>
                                            <span className="more" onClick={() => setNewSoglia(parseFloat(newSoglia) + 5)}><More /></span>
                                        </div>
                                        <p className="label" style={{textAlign: 'center', marginBottom: '30px'}}>
                                            La soglia non può essere inferiore a 5€
                                        </p>
                                    </>
                                )
                            }
                            {
                                idGroup === 3 ? (
                                    <>
                                        <p className="description">Il tuo piano non prevede la modifica della taglia.</p> 
                                        <div className="tagliaBox" style={{opacity: "0.5"}}>
                                            <span className="less" onClick={() => newTaglia === 10 ? null : setNewTaglia(parseFloat(newTaglia - 5))}><Less /></span>
                                            <p className='value'>{newTaglia}€</p>
                                            <span className="more" onClick={() => setNewTaglia(parseFloat(parseFloat(newTaglia) + 5))}><More /></span>
                                        </div>
                                        <p className="label" style={{textAlign: 'center'}}>
                                            La taglia non può essere inferiore a 10€
                                        </p>
                                    </>
                                ) : (
                                    <>
                                        <p className="description">Ricaricheremo automaticamente la <span className="bold">taglia</span> di:</p> 
                                        <div className="tagliaBox">
                                            <span className="less" onClick={() => newTaglia === 10 ? null : setNewTaglia(parseFloat(newTaglia - 5))}><Less /></span>
                                            <p className='value'>{newTaglia}€</p>
                                            <span className="more" onClick={() => setNewTaglia(parseFloat(parseFloat(newTaglia) + 5))}><More /></span>
                                        </div>
                                        <p className="label" style={{textAlign: 'center'}}>
                                            La taglia non può essere inferiore a 10€
                                        </p>
                                    </>
                                )
                            }
                        </div>
                        {/*<Moduli /> */}
                        {/* <SwiperButtonTS url={url}  forward={'/enrica/modifica-effettuata'}/> */}
                        <div className="forwardButton">
                            <button disabled={idGroup === 3 ? true : false} onClick={() => setStep(step + 1)}>Avanti <ArrowForwardIosIcon /></button>
                        </div>
                    </>
                ) : (
                    <>
                        <HeaderBack text="Taglia e soglia" step={step} setStep={setStep}/>
                        <div className="body recap">
                            {/* <p className="title">Taglia e soglia</p> */}
                            <p className="secondary">Ecco un riepilogo della tua richiesta</p>
                            {
                                idGroup === 2 || idGroup === 3 ? null : (
                                    <>
                                        <p className="description">La procedura partirà solo dopo l'avvenuto pagamento da parte del nuovo intestatario.</p> 
                                        
                                    </>
                                )
                            }

                            <p className="description">Ricaricheremo automaticamente la <span className="bold">taglia</span> di:</p> 
                            <div className="boxContainer">
                                <div className="box">
                                    <p className='main'>Soglia</p>
                                    <p className="secondary">{soglia} <span className="currency">€</span></p>
                                </div>
                                <div className="line"></div>
                                <div className="box">
                                    <p className='main'>Taglia</p>
                                    <p className="secondary">{taglia} <span className="currency">€</span></p>
                                </div>
                            </div>
                            <div className="change">
                                <Change />
                            </div>
                            <div className="boxContainer">
                                <div className="box">
                                    <p className='main'>Soglia</p>
                                    <p className="secondary">{newSoglia} <span className="currency">€</span></p>
                                </div>
                                <div className="line"></div>
                                <div className="box">
                                    <p className='main'>Taglia</p>
                                    <p className="secondary">{newTaglia} <span className="currency">€</span></p>
                                </div>
                            </div>
                            <ConfermaBTN text="Conferma il cambio" confermTxt={`Confermi soglia: ${newSoglia} e taglia: ${newTaglia}?`}  url={url} forward="/enrica/richiesta-inoltrata"/>
                        </div>
                    </>
                )}
                
            </div>
        </div>
    )
}
